import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import TableMap from './components/TableMap';
import ReservationForm, { ReservationData } from './components/ReservationForm';
import Confirmation from './components/Confirmation';

function App() {
  const [selectedTable, setSelectedTable] = useState<string | null>(null);
  const [reservation, setReservation] = useState<ReservationData | null>(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleTableSelect = (tableId: string) => {
    setSelectedTable(tableId);
  };

  const handleReservationSubmit = (formData: ReservationData) => {
    // In a real application, this would send the data to a backend server
    console.log('Reservation submitted:', formData);
    setReservation(formData);
    setShowConfirmation(true);
  };

  const handleNewReservation = () => {
    setSelectedTable(null);
    setReservation(null);
    setShowConfirmation(false);
  };

  return (
    <div className="App">
      <Header />

      <main className="main-content">
        {showConfirmation && reservation ? (
          <div className="container">
            <Confirmation
              reservation={reservation}
              onNewReservation={handleNewReservation}
            />
          </div>
        ) : (
          <section className="reservation-section">
            <div className="container">
              <h1 style={{ textAlign: 'center' }}>Reserve Your Table at SMSushi</h1>
              <p className="intro-text">
                Experience authentic Japanese cuisine in a beautiful setting.
                Select a table from our floor plan and make your reservation today.
              </p>

              <div className="reservation-container">
                <div className="table-map-section">
                  <TableMap
                    onSelectTable={handleTableSelect}
                    selectedTable={selectedTable}
                  />
                </div>

                <div className="form-section">
                  <ReservationForm
                    selectedTable={selectedTable}
                    onSubmit={handleReservationSubmit}
                  />
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} SMSushi. All rights reserved.</p>
          <p>123 Sushi Street, Foodville, CA 90210 | (555) 123-4567</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
